import directives from './module';
import {SmoothScroll} from '../services/SmoothScroll';

directives.directive('scrollTo', () =>
    (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: {scrollTo: string}) => angular.element(() => {
        const scrollSvc = new SmoothScroll(document.getElementById(attrs.scrollTo));
        element.on('click', () => scrollSvc.scroll());
    })
);



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/scrollToDirective.ts